import type { SVGProps } from "react";
export interface CandyCaneIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CandyCaneIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CandyCaneIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.54 16.767a1.125 1.125 0 0 1 1.4-.556l.106.046 4.37 2.16a1.126 1.126 0 0 1-.998 2.017l-4.368-2.16-.101-.057a1.124 1.124 0 0 1-.409-1.45m5.045-2.975c.278-.555.953-.78 1.509-.502l4.324 2.16a1.126 1.126 0 0 1-1.006 2.013l-4.325-2.16a1.126 1.126 0 0 1-.502-1.511m5.024-2.987c.26-.52.87-.751 1.404-.55l.105.046 4.327 2.164a1.124 1.124 0 0 1-1.006 2.013l-4.326-2.164-.1-.057a1.125 1.125 0 0 1-.404-1.452M22 6.875l.115.006a1.125 1.125 0 0 1 0 2.238l-.116.006h-4.025a1.125 1.125 0 0 1 0-2.25zm-4.442-.271a1.125 1.125 0 1 1-2.061-.902zm-.388-4.71a1.125 1.125 0 0 1 2.01 1.004l-1.622 3.706-2.061-.902 1.622-3.706.05-.103Z"
      />
      <path
        fill={color}
        d="M12.32 1.855c3.451-2.04 7.898-.781 9.857 2.692 1.881 3.337.884 7.606-2.29 9.708l-.315.196-13.929 8.234a3.157 3.157 0 0 1-4.358-1.172 3.183 3.183 0 0 1 1.149-4.3l13.96-8.252.148-.11a.94.94 0 0 0 .26-.978l-.076-.172-.023-.042a.86.86 0 0 0-1.187-.323 3.11 3.11 0 0 1-4.119-.88l-.173-.274-.04-.07a3.15 3.15 0 0 1 1.136-4.257m7.897 3.797c-1.355-2.403-4.412-3.242-6.752-1.859a.9.9 0 0 0-.32 1.214l.04.07.102.147a.86.86 0 0 0 1.084.176 3.11 3.11 0 0 1 4.292 1.154l.023.043.144.287a3.184 3.184 0 0 1-1.024 3.836l-.267.178-13.96 8.25a.934.934 0 0 0-.334 1.26.906.906 0 0 0 1.253.34l13.93-8.233c2.34-1.384 3.144-4.46 1.789-6.863"
      />
    </svg>
  );
}
